import React from "react";
import App from "../components/App";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class AppContainer extends React.Component {
  render() {
    return <App />;
  }
}

export default withRouter(
  connect(state => ({
    // language: state.i18n.language,
    // locale: state.i18n.locale
  }))(AppContainer)
);
